/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const LockedIcon: React.FC = (): JSX.Element => (
  <svg width="9" height="10" viewBox="0 0 9 10" fill="#6A6A6A" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.506329 5.44304C0.506329 4.88376 0.959712 4.43038 1.51899 4.43038H6.58228C7.14155 4.43038 7.59494 4.88376 7.59494 5.44304V8.48101C7.59494 9.04029 7.14155 9.49367 6.58228 9.49367H1.51899C0.959712 9.49367 0.506329 9.04029 0.506329 8.48101V5.44304Z" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 5.44304C0 4.60412 0.680074 3.92405 1.51899 3.92405H6.58228C7.42119 3.92405 8.10127 4.60412 8.10127 5.44304V8.48101C8.10127 9.31993 7.42119 10 6.58228 10H1.51899C0.680074 10 0 9.31993 0 8.48101V5.44304ZM1.51899 4.93671C1.23935 4.93671 1.01266 5.1634 1.01266 5.44304V8.48101C1.01266 8.76065 1.23935 8.98734 1.51899 8.98734H6.58228C6.86192 8.98734 7.08861 8.76065 7.08861 8.48101V5.44304C7.08861 5.1634 6.86192 4.93671 6.58228 4.93671H1.51899Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.05063 0.759494C3.14181 0.759494 2.40506 1.49624 2.40506 2.40506V4.05063H5.6962V2.40506C5.6962 1.49624 4.95944 0.759494 4.05063 0.759494ZM1.64557 2.40506C1.64557 1.07678 2.72235 0 4.05063 0C5.37889 0 6.4557 1.07678 6.4557 2.40506V4.81013H1.64557V2.40506Z"
    />
  </svg>
);
